import React from "react";
import NewPVCollection from "../../sub-treasury/pv-collection/NewPVCollection";

const MdaGeneratePV = () => {
  return <NewPVCollection />;
};

export default MdaGeneratePV;
